import React, { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

const EASE = [0.76, 0, 0.24, 1];
const words = ["Denver", "By hand", "For life", "Bulow"];

export default function Preloader({ onDone }) {
  const [i, setI] = useState(0);
  const [done, setDone] = useState(false);

  useEffect(() => {
    if (sessionStorage.getItem("bulow-seen")) { setDone(true); onDone?.(); return; }
    const t = setInterval(() => setI((v) => v + 1), 900);
    const end = setTimeout(() => { clearInterval(t); setDone(true); sessionStorage.setItem("bulow-seen", "1"); onDone?.(); }, 900 * words.length + 500);
    return () => { clearInterval(t); clearTimeout(end); };
  }, [onDone]);

  return (
    <AnimatePresence>
      {!done && (
        <motion.div className="pre" initial={{ y: 0 }} exit={{ y: "-100%" }} transition={{ duration: 1.1, ease: EASE }}>
          <div className="pre-inner">
            <AnimatePresence mode="wait">
              <motion.span key={Math.min(i, words.length - 1)} className="pre-word"
                initial={{ opacity: 0, y: 24 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0, y: -24 }} transition={{ duration: 0.55, ease: [0.16, 1, 0.3, 1] }}>
                {words[Math.min(i, words.length - 1)]}
              </motion.span>
            </AnimatePresence>
            <motion.div className="pre-bar" initial={{ scaleX: 0 }} animate={{ scaleX: 1 }} transition={{ duration: 900 * words.length / 1000, ease: "linear" }} />
          </div>
          <style dangerouslySetInnerHTML={{ __html: `
            .pre { position: fixed; inset: 0; z-index: 10000; background: var(--ink); display: grid; place-items: center; }
            .pre-inner { display: grid; gap: 26px; justify-items: center; }
            .pre-word { font-family: var(--serif); font-style: italic; font-weight: 300; font-size: clamp(2.4rem, 6vw, 5.5rem); color: var(--ivory); line-height: 1; }
            .pre-bar { width: 160px; height: 1px; background: var(--gold); transform-origin: left; }
          ` }} />
        </motion.div>
      )}
    </AnimatePresence>
  );
}
